import { PermissionsScope } from '../../policies/policy.model'
import { InvoiceType } from '../models/invoice.types'

export const INVOICE_SCOPE: PermissionsScope = 'invoices'
export const INVOICE_FRAGMENT = 'invoice'
export const INVOICE_ROW_FRAGMENT = 'invoice-row'
export const PROMOTION_FRAGMENT = 'promotion'

export const INVOICE_TYPES: { code: InvoiceType; name: string }[] = [
  {
    code: 'INVOICE',
    name: 'Invoice',
  },
  {
    code: 'CREDIT_NOTE',
    name: 'Credit note',
  },
  {
    code: 'RECEIPT',
    name: 'Receipt',
  },
  {
    code: 'RECEIPT_FISCALCODE',
    name: 'Receipt fiscal code',
  },
  {
    code: 'RETURN',
    name: 'Goods return',
  },
  {
    code: 'GENERIC',
    name: 'Generic',
  },
]
